import {
    AnyAction,
    CaseReducer,
    createAsyncThunk,
} from '@reduxjs/toolkit'

import {
    NinchatActionType,
    NinchatAddMemberAction,
} from 'api/types/actions'

import ninchatClient, {
    NinchatActionParams,
    NinchatClientPromiseValue,
} from 'api/NinchatClient'


import {NinchatState} from 'api/types'
import {queueMemberJoined} from 'api/event/queueMemberJoined'
import {realmMemberJoined} from 'api/event/realmMemberJoined'

const actionTypePrefix = 'NINCHAT/action'

type MetaReducerAsyncThunkConfig = {fulfilledMeta: {reducer: CaseReducer}}

export const addMember = createAsyncThunk<NinchatClientPromiseValue, NinchatActionParams<NinchatAddMemberAction>, MetaReducerAsyncThunkConfig>(
    `${actionTypePrefix}/${NinchatActionType.NinchatAddMemberAction}`,
    async (arg, thunkAPI) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatAddMemberAction

        /* eslint-disable indent, multiline-ternary */
        const meta = {
            reducer:
                params.channel_id ? () => undefined : // to be defined
                params.queue_id ? (state: NinchatState, action: AnyAction) => queueMemberJoined(state, action) :
                params.realm_id ? realmMemberJoined :
                () => undefined,
}
        /* eslint-enable */

        try {
            const reply = await ninchatClient.send(params)
            return thunkAPI.fulfillWithValue(reply, meta)
        } catch (err) {
            return thunkAPI.rejectWithValue(err)
        }
    },
)
